import { t } from "@lingui/core/macro";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useMemo } from "react";
import { FormField } from "../../form-field";

type ParameterInputForDevsProps = {
  layer: {
    model?: string;
    parameter_unit?: string;
  };
  changeProps: (partial: Partial<{ model: string; parameter_unit: string }>) => void;
};

export function ParameterInputForDevs({ layer, changeProps }: ParameterInputForDevsProps) {
  const [tmpModelInput, setTmpModelInput] = useState(layer.model ?? "");
  const [tmpParameterInput, setTmpParameterInput] = useState(layer.parameter_unit ?? "");

  const debouncedChange = useMemo(
    () =>
      debounce((name: string, value: string) => {
        changeProps({ [name]: value });
      }, 1000),
    [changeProps],
  );

  useEffect(() => {
    const model = layer.model ?? "";
    const parameter = layer.parameter_unit ?? "";

    setTmpModelInput((prev) => (prev !== model ? model : prev));
    setTmpParameterInput((prev) => (prev !== parameter ? parameter : prev));
  }, [layer]);

  const handleModelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTmpModelInput(value);
    debouncedChange("model", value);
  };

  const handleParameterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTmpParameterInput(value);
    debouncedChange("parameter_unit", value);
  };

  return (
    <>
      <FormField label={t`Source`}>
        <input
          name="model"
          type="text"
          value={tmpModelInput}
          onChange={handleModelChange}
          className="w-full px-2 py-1 border rounded"
        />
      </FormField>
      <FormField label={t`Parameter`}>
        <input
          name="parameter_unit"
          type="text"
          value={tmpParameterInput}
          onChange={handleParameterChange}
          className="w-full px-2 py-1 border rounded"
        />
      </FormField>
    </>
  );
}
